import utils from '@/mixins/utils.js'

export const dataFieldsPercentual = {
  CNES: 'nu_cnes',
  UBS: 'no_unidade_saude',
  INE: {
    field: 'nu_ine',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  Equipe: 'no_equipe',
  Nota: 'nota',
  Classificação: 'classificacao',
}

export const infoHtml = `
`
